import "./CreateOnboardingStep.css";

import { Editor as TinyEditor } from "@tinymce/tinymce-react";
import { Breadcrumb, Button, Form, Input, message, Select } from "antd";
import { useEffect, useState } from "react";
import { BsTrash } from "react-icons/bs";
import { CgScreen } from "react-icons/cg";
import { IoMdAdd } from "react-icons/io";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { editorApiKey } from "../../../_config/constants";
import {
  createOnboardingStep,
  deleteOnboardingStep,
  getOnboardingSteps,
  type OnboardingStepsFormType,
  updateOnboardingSteps,
  useAppSelector,
} from "../../../_lib/_store";
import { stripHtml } from "../../../_lib/_utils";

export const CreateOnboardingStepPage = ({
  type,
}: {
  type: "create" | "edit";
}) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.onboardingSteps);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isLoading: onboardingStepsLoading, onboardingSteps } = useAppSelector(
    (state) => state.onboardingSteps,
  );
  const [tips, setTips] = useState<string[]>([]);

  const isEdit = type === "edit";

  useEffect(() => {
    const onboardingStep = state?.onboardingStep;
    if (isEdit && !onboardingStep) {
      navigate("/onboarding-step");
    }
    form.setFieldsValue(onboardingStep);
    setTips(onboardingStep?.tips || []);
    console.log(
      "🚀 ~ CreateOnboardingStepPage ~ tips:",
      tips,
      onboardingStep?.tips,
    );
  }, [state]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getOnboardingSteps(messageApi);
  };

  const handleSubmit = async (values: OnboardingStepsFormType) => {
    const payload = {
      ...values,
      order: Number(values?.order),
      tips,
      ...(isEdit ? { id: state.onboardingStep.id } : {}),
    };

    if (isEdit) {
      const res = await updateOnboardingSteps(messageApi, payload);
      if (res) {
        navigate("/onboarding-step/edit", {
          state: { onboardingStep: res },
          replace: true,
        });
      }
    } else {
      const res = await createOnboardingStep(messageApi, payload);
      if (res) {
        form.resetFields();
        setTips([]);
      }
    }
  };

  const handleDelete = async () => {
    const res = await deleteOnboardingStep(messageApi, state.onboardingStep.id);
    if (res) {
      navigate("/onboarding-step");
    }
  };

  const types = [
    { id: "main", name: "main" },
    { id: "checkbox", name: "checkbox" },
    { id: "file_upload", name: "file_upload" },
    { id: "registration_list", name: "registration_list" },
    { id: "form", name: "form" },
  ];

  const handleAddTag = () => {
    setTips([...tips, ""]);
  };
  const handleChangeTag = (index: number, value: string) => {
    const newTips = [...tips];
    newTips[index] = value;
    setTips(newTips);
  };
  const handleRemoveTag = (index: number) => {
    const newTips = tips.filter((_, i) => i !== index);
    setTips(newTips);
  };

  interface TinyMCEFormItemProps {
    value?: string; // AntD Form se aane wali value
    onChange?: (value: string) => void; // AntD Form ke liye callback
  }
  const TinyMCEFormItem = ({ value = "", onChange }: TinyMCEFormItemProps) => {
    return (
      <TinyEditor
        apiKey={editorApiKey}
        init={{
          plugins: ["link", "removeformat"],
          toolbar: "bold italic link removeformat",
          menubar: false,
          height: 300,
          branding: false,
          promotion: false,
          statusbar: false,
          resize: false,
        }}
        value={value}
        onEditorChange={(content) => {
          onChange?.(content);
        }}
      />
    );
  };

  return (
    <>
      {contextHolder}
      <div className="createPackage">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/onboarding-step">Onboarding Step</Link>,
            },
            {
              title: isEdit ? "Edit" : "Create new",
            },
          ]}
        />

        {!isEdit ? (
          <h2 className="title">Create new</h2>
        ) : (
          <div className="titleHeader">
            <h2 className="title">Edit</h2>
            <div className="actionButton">
              <Button
                icon={<CgScreen size={17} />}
                size="large"
                onClick={() =>
                  navigate(`/onboarding-step/show`, {
                    state: { onboardingStep: state?.onboardingStep },
                  })
                }
              >
                Show
              </Button>
              <Button
                icon={<BsTrash />}
                size="large"
                onClick={handleDelete}
                loading={isLoading}
              >
                Delete
              </Button>
            </div>
          </div>
        )}

        <div className="form">
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              label="Title"
              name="title"
              rules={[
                {
                  required: true,
                  message: "Onboarding step title is required",
                },
              ]}
            >
              <TinyMCEFormItem />
            </Form.Item>

            <Form.Item label="Description" name="description">
              <TinyMCEFormItem />
            </Form.Item>

            <Form.Item
              label="Step Key"
              name="stepKey"
              rules={[{ required: true, message: "Step key is required" }]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Type"
              name="type"
              rules={[{ required: true, message: "Type is Required" }]}
            >
              <Select
                size="large"
                options={types?.map((v) => ({
                  label: v?.name,
                  value: v?.id,
                }))}
              />
            </Form.Item>

            <Form.Item
              label="Order"
              name="order"
              rules={[{ required: true, message: "Order is required" }]}
            >
              <Input size="large" type="number" />
            </Form.Item>

            <Form.Item label="Parent Id" name="parentId">
              <Select
                loading={onboardingStepsLoading}
                size="large"
                options={onboardingSteps?.map((s) => ({
                  label: stripHtml(s?.title),
                  value: s?.id,
                }))}
                allowClear
              />
            </Form.Item>

            <Form.Item label="Video Url" name="videoUrl">
              <Input size="large" />
            </Form.Item>

            <Form.Item label="Tips" name="tips">
              <div className="tagBox">
                {tips?.map((v, i) => {
                  return (
                    <div key={i} className="tagInputBox">
                      <p>{i + 1}</p>
                      <Input
                        className="tagInput"
                        size="large"
                        value={v}
                        onChange={(e) => {
                          handleChangeTag(i, e.target.value);
                        }}
                      />
                      <BsTrash
                        className="trashIcon"
                        onClick={() => {
                          handleRemoveTag(i);
                        }}
                      />
                    </div>
                  );
                })}

                <Button
                  icon={<IoMdAdd />}
                  size="large"
                  className="addButton"
                  onClick={handleAddTag}
                >
                  Add new Item
                </Button>
              </div>
            </Form.Item>

            <Form.Item label="Checkbox Tip Bar" name="checkboxTipBar">
              <Input size="large" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                style={{ width: "150px" }}
                loading={isLoading}
              >
                {isEdit ? "Update" : "Save"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
};
